import { render } from "./StackedBarchartfordate.vue?vue&type=template&id=aa4b60f0&scoped=true"
import script from "./StackedBarchartfordate.vue?vue&type=script&lang=js"
export * from "./StackedBarchartfordate.vue?vue&type=script&lang=js"

import "./StackedBarchartfordate.vue?vue&type=style&index=0&id=aa4b60f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4b60f0"]])

export default __exports__